import React from 'react';
import { useRouter } from 'next/router';
import type { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';

import { Release as ReleaseView } from 'components/views/Release';
import { faqRelease } from 'content/faq';
import { StrapiService } from 'lib/strapi/StrapiService';
import { MagazineArticleCard } from 'components/sections/Magazine';

interface Props {
  articles: MagazineArticleCard[];
}

const Release: NextPage<Props> = ({ articles }) => {
  const router = useRouter();

  const canonicalUrl = `https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}${router.asPath}`;
  return (
    <>
      <Head>
        <title>Lägg om din företagsleasing - Blipp</title>
        <meta property="og:title" content="Lägg om din företagsleasing - Blipp" />
        <meta
          property="og:description"
          content="Med Blipp kan du lägga om ditt nuvarande leasingavtal på din företagsbil och se över dina kostnader."
        />
        <meta
          name="description"
          content="Med Blipp kan du lägga om ditt nuvarande leasingavtal på din företagsbil och se över dina kostnader."
        />
        <link rel="canonical" key="canonical" href={canonicalUrl} />
      </Head>
      <ReleaseView faq={faqRelease} articles={articles} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const articles = await StrapiService.getLatestMagazineArticles(3);
  return {
    props: {
      articles,
    },
  };
};

export default Release;
